import { useState, useContext, createContext, useEffect } from "react";
import { fAuth } from "../config/firebase";
import { useAuthState } from "react-firebase-hooks/auth";
const authContext = createContext();

function useAuth() {
  const [authed, setAuthed] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);

  const [user, loading] = useAuthState(fAuth);

  useEffect(() => {
    // Keep auth state in sync with Firebase user once auth is ready.
    if (!loading) {
      setAuthed(!!user);
      setIsInitialized(true);
    }
  }, [loading, user]);

  return {
    authed,
    setAuthed,
    loading: loading || !isInitialized,
  };
}

// function useAuth() {
//   const [user, loading, error] = useAuthState(fAuth);

//   return {
//     authed: !!user,
//     user,
//     loading,
//   };
// }

export function AuthProvider({ children }) {
  const auth = useAuth();

  return <authContext.Provider value={auth}>{children}</authContext.Provider>;
}

export function useAuthContext() {
  return useContext(authContext);
}
